import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import * as fromRouter from '@ngrx/router-store';
import * as fromUser from './user.reducer';
import * as fromUtility from './utility.reducer';
import * as fromLicense from './license.reducer';
import * as fromLink from './link.reducer';
import * as fromPolicy from './policy.reducer';
import * as fromAffiliate from './affiliate.reducer';
import { RouterStateUrl } from '@core/utils/serializers/route.serializer';
import { transferStateMetaReducer } from '@shared/utils/functions/store.function';

export interface State {
  [fromUser.userFeatureKey]: fromUser.State;
  [fromUtility.utilityFeatureKey]: fromUtility.State;
  [fromLicense.licenseFeatureKey]: fromLicense.State;
  [fromLink.linkFeatureKey]: fromLink.State;
  [fromPolicy.policyFeatureKey]: fromPolicy.State;
  [fromAffiliate.affiliateFeatureKey]: fromAffiliate.State;
  router: fromRouter.RouterReducerState<RouterStateUrl>;
}

export const reducers: ActionReducerMap<State> = {
  [fromUser.userFeatureKey]: fromUser.reducer,
  [fromUtility.utilityFeatureKey]: fromUtility.reducer,
  [fromLicense.licenseFeatureKey]: fromLicense.reducer,
  [fromLink.linkFeatureKey]: fromLink.reducer,
  [fromPolicy.policyFeatureKey]: fromPolicy.reducer,
  [fromAffiliate.affiliateFeatureKey]: fromAffiliate.reducer,
  router: fromRouter.routerReducer,
};

export const metaReducers: MetaReducer<State>[] = [transferStateMetaReducer('coreState')];
